import React from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {MessageTypeTitles, MessageTypeFilters} from "root/DataFunctions/Constants";

const ApprovalsAppBodyHeader= (props) =>
{

    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const displayHeader = () =>
    {
        switch (queryParams.type)
        {
            case MessageTypeFilters.MESSAGE_TYPE_ALL:
                return <h4 className="title">{MessageTypeTitles.MESSAGE_TYPE_ALL}</h4>
                break;

            case MessageTypeFilters.MESSAGE_TYPE_LIFESTORY:
                return <h4 className="title">{MessageTypeTitles.MESSAGE_TYPE_LIFESTORY}</h4>
                break;

            case MessageTypeFilters.MESSAGE_TYPE_MESSAGE:
                return <h4 className="title">{MessageTypeTitles.MESSAGE_TYPE_MESSAGE}</h4>
                break;

            default:
                return <h4 className="title">{MessageTypeTitles.MESSAGE_TYPE_ALL}</h4>
                break;
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default ApprovalsAppBodyHeader;
